export default `
query allServices($contractorCompanyId: Int!, $customerId: Int!) {
   allServices(contractorCompanyId: $contractorCompanyId, customerId: $customerId) {
    id
    name
    subServiceId
  }
}
`
